import { render, staticRenderFns } from "./cadcontasbancarias.vue?vue&type=template&id=2cbae9e5&"
import script from "./cadcontasbancarias.vue?vue&type=script&lang=js&"
export * from "./cadcontasbancarias.vue?vue&type=script&lang=js&"
import style0 from "./cadcontasbancarias.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports